
import axios from "axios";

//Your Keycloak details
const KEYCLOAK_URL =
  process.env.REACT_APP_KEYCLOAK_URL ;

// Create axios instance
const lttylApi = axios.create({
  baseURL: process.env.REACT_APP_LTTL_URL || "/api",
});

// Helper: check expiry
function isTokenExpired() {
  const expiry = localStorage.getItem("token_expiry");
  if (!expiry) return true;
  return Date.now() > parseInt(expiry, 10);
}

// Helper: request new token
async function fetchNewToken() {
  const params = new URLSearchParams();
  params.append("grant_type", "client_credentials");
  params.append("client_id", process.env.REACT_APP_CLIENT_ID);
  params.append("client_secret", process.env.REACT_APP_CLIENT_SECRET);

  const res = await axios.post(KEYCLOAK_URL, params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  const { access_token, expires_in } = res.data;

  // Save token + expiry
  localStorage.setItem("access_token", access_token);
  localStorage.setItem(
    "token_expiry",
    (Date.now() + expires_in * 1000).toString()
  );

  return access_token;
}

// Interceptor
lttylApi.interceptors.request.use(async (config) => {
  let token = localStorage.getItem("access_token");

  if (!token || isTokenExpired()) {
    token = await fetchNewToken();
  }

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default lttylApi;
